<div class="row button-container">
  <div class="col-2 custom-button">
    @if (enableFeatureTouchDimCheckbox) {
      <div class="signifyBookmd rSet">Enable feature
        <input type="checkbox" class="primary-checkbox" id="enable-touchDim" [checked]="isEnableTouchDimFeature"
          [(ngModel)]="isEnableTouchDimFeature" (change)="enableFeature($event.target.checked)" />
          <!-- added id here -->
          <label for="enable-touchDim"><span id="TouchDim-enable-feature-checkbox" class="extra-border-enablefeat"></span></label>
        </div>
      }
    </div>

    <div class="col-8"></div>
    <div class="col-1"></div>
  </div>

  <div class="row slider-container" [ngClass]="{'isResetDisabled': isResetDisabled===true}">
    @if (hasTouchDimTwEnabled()) {
      <div class="col-2 signifyBookmd rSet nowrapCss">Enable Tunable White control
        <input type="checkbox" class="primary-checkbox" id="enable-twControl" [checked]="isTwEnabled"
          [(ngModel)]="isTwEnabled" [disabled]="isResetDisabled"
          (change)="twEnabledChanged($event.target.checked)" />
        <label for="enable-twControl" aria-label="Enable Tunable White control"><span id="TouchDim-enable-twControl-checkbox" class="extra-border-enablefeat"></span></label>
      </div>
      <div class="col-12"></div>
    }
    <div class="col-2 mt-20 signifyBookmd rSet nowrapCss">Use last known level
      <input type="checkbox" class="primary-checkbox" id="enable-lastKnown" [checked]="isLastKnownEnabled"
        [(ngModel)]="isLastKnownEnabled" [disabled]="isResetDisabled"
        (change)="lastKnownEnabled($event.target.checked)" />
        <!-- added id here -->
        <label for="enable-lastKnown" aria-label="Use last known level"><span id="TouchDim-enable-lastKnown-checkbox"class="extra-border-enablefeat"></span></label>
      </div>
      <div class="col-12"></div>

        <div class="col-1 label startupLabel nowrapCss mt-20">
        Power on level</div>
        @if (quickConfigvalue) {
          <div class="col-2 filters-heading mt-20">
            <div class="row">
              <div class="col-2"></div>
              <div class="col-2 minValMargin">
                <span class=" signifyBookmd minValue"> min {{floorValue}}</span>
              </div>
              <div class="col-1">
                <span class="signifyBookmd maxValue"> max {{ceilValue}}</span>
              </div>
            </div>
          </div>
        }
        <!-- added id here -->
        @if (!quickConfigvalue) {
          <span id ="TouchDim-minPowerValue" class="label minValueCss col-1 mt-20">{{floorValue}}</span>
        }
        @if (!quickConfigvalue) {
          <div class="col-6 sliderCss mt-20" [ngClass]="{'isResetDisabled': sliderDisabled}">
            <!--added  test id as 'id' slideClick used multiple places in UI-->
            <div id="sliderClick" testid="TouchDim-slider" [ngClass]="{'isResetDisabled': sliderDisabled}">
              <ngx-slider type="normalType" [options]=valOptions [(value)]=sliderValue
                (userChangeEnd)="sliderValueChange($event.value)">
              </ngx-slider>
            </div>
          </div>
        }
        <!-- added id here -->
        @if (!quickConfigvalue) {
          <span id ="TouchDim-maxPowerValue" class="label col-1 maxValueCss mt-20">{{ceilValue}}</span>
        }
        <div class="row form-group col-3 nowrapCss mt-20">
          <div class="d-flex align-items-center">
            <input type="text" id="TouchDim-powerValue-inputbox" [(ngModel)]="textboxValue" (input)="valueChanged($event.target.value)"
              style="width: 5em;"
              (keypress)="numberOnly($event)"
              [ngClass]="{'isResetDisabled': sliderDisabled, 'custom-inputbox-disabled': sliderDisabled, 'myStyle': inputError===true, 'inputCssStandard': quickConfigvalue===true}"
              class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
              [disabled]="sliderDisabled ? true : false" />
              <!-- added id here -->
              <p class="signifyBookmd mb-0 ml-2" id="TouchDim-power-percent" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">
                (&#8776;{{calculatedPercentageVal}} %)
              </p>
            </div>
          </div>
        <div class="col-12"></div>

        @if (hasPowerOnCCT()) {
          <div class="col-1 label startupLabel nowrapCss mt-20">Power on CCT</div>
          @if (quickConfigvalue) {
            <div class="col-2 filters-heading mt-20">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-2 minValMargin">
                  <span class="signifyBookmd minValue"> min {{cctFloorValue}}</span>
                </div>
                <div class="col-1">
                  <span class="signifyBookmd maxValue"> max {{cctCeilValue}}</span>
                </div>
              </div>
            </div>
          }
          @if (!quickConfigvalue) {
            <span id="TouchDim-minCctValue" class="label minValueCss col-1 mt-20">{{cctFloorValue}}</span>
          }
          @if (!quickConfigvalue) {
            <div class="col-6 sliderCss mt-20" [ngClass]="{'isResetDisabled': cctSliderDisabled}">
              <div id="cctSliderClick" testid="TouchDim-cct-slider" [ngClass]="{'isResetDisabled': cctSliderDisabled}">
                <ngx-slider type="normalType" [options]="cctValOptions" [(value)]="cctSliderValue"
                  (userChangeEnd)="cctSliderValueChange($event.value)">
                </ngx-slider>
              </div>
            </div>
          }
          @if (!quickConfigvalue) {
            <span id="TouchDim-maxCctValue" class="label col-1 maxValueCss mt-20">{{cctCeilValue}}</span>
          }
          <div class="row form-group col-3 nowrapCss mt-20">
            <div class="d-flex align-items-center">
              <input type="text" id="TouchDim-cctValue-inputbox" [(ngModel)]="cctTextboxValue"
                (input)="cctValueChanged($event.target.value)"
                style="width: 5em;"
                (keypress)="numberOnly($event)"
                [ngClass]="{'isResetDisabled': cctSliderDisabled, 'custom-inputbox-disabled': cctSliderDisabled, 'myStyle': cctInputError===true, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                [disabled]="cctSliderDisabled ? true : false" />
              <p class="signifyBookmd mb-0 ml-2" id="TouchDim-cct-unit" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">K</p>
            </div>
          </div>
        }
        <div class="col-12"></div>
        <div class="col-2 mt-20 signifyBookmd rSet nowrapCss">Ignore toggle limits
          <input type="checkbox" class="primary-checkbox" id="enable-toggleLimit" [checked]="isToggleLimitEnabled"
            [(ngModel)]="isToggleLimitEnabled" [disabled]="isResetDisabled"
            (change)="toggleLimitEnabled($event.target.checked)" />
          <!-- added id here -->
          <label for="enable-toggleLimit" class="pdl-6" aria-label="Ignore toggle limits"><span id="TouchDim-ignore-toggleLimit-checkbox" class="extra-border-enablefeat"></span></label>
        </div>
        <div class="col-12"></div>
        @if (hasTouchDimTwEnabled()) {
          <div class="row note-back-new touchdim-note-row" id="TouchDim-tw-note">
            <span class="col-11 note-text signifyBookmd"><span class="signifyBoldmd">Note:</span> When Touch and Dim for Tunable White is enabled, the settings in the FlexTune menu must also be configured.</span>
          </div>
        }
      </div>
